import { __assign } from 'tslib';
var getSizeOfTypeaheadResults = function (typeaheadResults) {
  /* eslint-disable-next-line default-case */
  switch (typeaheadResults.type) {
    case 'categorized':
      return typeaheadResults.items.reduce(function (sum, currentItem) {
        return sum + currentItem.typeaheadResults.length;
      }, 0);
    case 'uncategorized':
      return typeaheadResults.items.length;
  }
};
var filterTypeaheadResults = function (typeaheadResults, values) {
  /* eslint-disable-next-line default-case */
  switch (typeaheadResults.type) {
    case 'categorized':
      return __assign(__assign({}, typeaheadResults), {
        items: typeaheadResults.items.map(function (category) {
          return __assign(__assign({}, category), {
            typeaheadResults: category.typeaheadResults.filter(function (item) {
              return !values.includes(item.value);
            })
          });
        })
      });
    case 'uncategorized':
      return __assign(__assign({}, typeaheadResults), {
        items: typeaheadResults.items.filter(function (item) {
          return !values.includes(item.value);
        })
      });
  }
};
var selectTypeaheadResultIndex = function (typeaheadResults, index) {
  /* eslint-disable-next-line default-case */
  switch (typeaheadResults.type) {
    case 'categorized':
      {
        return typeaheadResults.items.reduce(function (items, currentItem) {
          items.push.apply(items, currentItem.typeaheadResults);
          return items;
        }, [])[index];
      }
    case 'uncategorized':
      return typeaheadResults.items[index];
  }
};
export { filterTypeaheadResults, getSizeOfTypeaheadResults, selectTypeaheadResultIndex };